import React, { useEffect, useState } from 'react';
import {
  Box,
  Radio,
  RadioGroup as MUIRadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Typography,
  Stack,
} from '@mui/material';

type RadioOptionType = {
  label: string;
  value: string;
  disabled?: boolean;
};

type RadioGroupType = {
  ownerOptions: RadioOptionType[];
  businessOptions: RadioOptionType[];
  dncOptions: RadioOptionType[];
  onChange?: (value: string) => void;
  label?: string;
  defaultValue?: string;
  /** Shown on the right inside each bordered box (e.g. "$10") */
  llcCost?: number;
  rowCost?: number;
  isBlacklistFree?: boolean;
};

const boxSx = {
  border: 2,
  borderColor: 'primary.main',
  borderRadius: 3,
  p: 1.5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
} as const;

const RadioGroup: React.FC<RadioGroupType> = ({
  label,
  ownerOptions,
  businessOptions,
  dncOptions,
  defaultValue,
  onChange,
  llcCost,
  rowCost,
  isBlacklistFree,
}) => {
  const [selectedValue, setSelectedValue] = useState<string>(defaultValue || '');

  useEffect(() => {
    if (defaultValue !== undefined) {
      setSelectedValue(defaultValue);
    }
  }, [defaultValue]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    onChange?.(newValue);
  };

  const renderPrice = (price: number | undefined, decimals = 3) => {
    // if (isBlacklistFree && price === 0.01) {
    //   return (
    //     <Typography
    //       component="span"
    //       variant="h6"
    //       sx={{
    //         color: 'primary.main',
    //         fontWeight: 600,
    //         flexShrink: 0,
    //         alignSelf: 'center',
    //       }}
    //     >
    //       Free
    //     </Typography>
    //   );
    // }

    if (price == null) {
      return null;
    }

    return (
      <Typography
        component="span"
        variant="h6"
        sx={{
          color: 'primary.main',
          fontWeight: 600,
          flexShrink: 0,
          alignSelf: 'center',
        }}
      >
        {`$${price.toFixed(decimals)}/record`}
      </Typography>
    );
  };

  const renderLabels = (opts: RadioOptionType[]) => {
    return opts.map((option) => (
      <FormControlLabel
        key={option.value}
        value={option.value}
        control={<Radio />}
        label={option.label}
        disabled={option.disabled ?? false}
      />
    ));
  };

  return (
    <FormControl fullWidth>
      <FormLabel color="primary">{label}</FormLabel>
      <MUIRadioGroup value={selectedValue} onChange={handleChange}>
        <Stack spacing={2} sx={{ width: '100%', mt: 1 }}>
          <Box sx={boxSx}>
            <Stack sx={{ flex: 1, gap: 0 }}>{renderLabels(ownerOptions)}</Stack>
            {renderPrice(rowCost)}
          </Box>
          <Box sx={boxSx}>
            <Stack sx={{ flex: 1, gap: 0 }}>{renderLabels(businessOptions)}</Stack>
            {renderPrice(llcCost)}
          </Box>
          <Box sx={boxSx}>
            <Stack sx={{ flex: 1, gap: 0 }}>{renderLabels(dncOptions)}</Stack>
            {renderPrice(0.01, 2)}
          </Box>
        </Stack>
      </MUIRadioGroup>
    </FormControl>
  );
};

export default RadioGroup;
